import logo from '../../assets/logo.png';
import '../Register/Register.css';
import '../../assets/fonts/Poppins-Bold.ttf';
import { useState } from 'react';
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from '../../firbase.config';
import { getDatabase, ref, onValue } from "firebase/database";
import { useNavigate } from 'react-router-dom';
import Spinner from '../../Components/Loader';
import { loginUserData, savePhone } from '../../redux/loginSlice';
import { useDispatch } from 'react-redux';

function Login() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [valid, setvalid] = useState(false);
  const [loader, setLoader] = useState(false)
  const dispatch = useDispatch();

  const db = getDatabase();
  var md5 = require('md5');
  const navigate = useNavigate();

  const handlePhoneChange = (e) => {
    setPhoneNumber(e.target.value)
  }
  const handlePasswordChange = (e) => {
    let pwd = e.target.value
    if (pwd.length >= 6) {
      setvalid(true)
    }
    setPassword(e.target.value)
  }

  const LoginUser = () => {
    setLoader(true)
    if (!isNaN(phoneNumber)) {
      if (phoneNumber.startsWith("+91")) {
        alert("Please Enter Phone Number Without +91")
        setLoader(false)
      }
      else if (phoneNumber.length > 10 || phoneNumber.length < 10) {
        alert("Please Enter Proper Phone Number")
        setLoader(false)
      } else {
        const starCountRef = ref(db, 'Users/+91' + phoneNumber + '/data/');
        onValue(starCountRef, (snapshot) => {
          const data = snapshot.val();
          if (data != null) {
            if (data.blocked === false) {
              if (data.role === "user") {
                signInWithEmailAndPassword(auth, data.email, md5(data?.city))
                  .then((userCredential) => {
                    const userDataString = JSON.stringify(userCredential.user);
                    localStorage.setItem('userToken', userDataString)
                    localStorage.setItem('userPhone', "+91" + phoneNumber)
                    dispatch(loginUserData(userDataString))
                    dispatch(savePhone("+91" + phoneNumber))

                    navigate('/', { replace: true })
                  })
                  .catch((error) => {
                    alert("Something went wrong please try again")
                    setLoader(false)
                  });
              } else {
                signInWithEmailAndPassword(auth, data.email, md5(password))
                  .then((userCredential) => {
                    const userDataString = JSON.stringify(userCredential.user);
                    localStorage.setItem('userToken', userDataString)
                    localStorage.setItem('userPhone', "+91" + phoneNumber)
                    dispatch(loginUserData(userDataString))
                    dispatch(savePhone("+91" + phoneNumber))

                    navigate('/dash', { replace: true })
                  })
                  .catch((error) => {
                    alert("Invalid password or something went wrong")
                    setLoader(false)
                  });
              }
            } else {
              alert("This user is blocked, Please contact admin")
              setLoader(false)
            }
          } else {
            alert("User with phone number not registered")
            setLoader(false)
          }
        });
      }
    } else {
      alert("Phone Number should contaion only numbers");
      setLoader(false)
    }
  }



  return (
    <div className="background" style={{ height: window.innerHeight }}>
      <Spinner visible={loader} />
      <div className="login-banner">
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 40 }}>
          <div>
            <img src={logo} alt="" style={{ width: 70, height: 70, marginRight: 20 }} />
          </div>
          <div>
            <h3 className='logo-name'>GMB COMPLEX</h3>
          </div>
        </div>
        <div >
          <p className="name">
            GOWRI <br />
            PRASANNA <br />
            CONVENTION <br />
            HALL <br />
          </p>
        </div>
      </div>


      <div className="">
        <div className="row">
          <div className="col-lg-6">
            <div
              style={{
                width: 420,
                backgroundColor: 'var(--color-white)',
                borderRadius: 'var(--radius-md)',
                boxShadow: '0 8px 30px rgba(0,0,0,0.15)',
              }}
            >
              <div className="card-body" style={{ padding: 32 }}>
                <div className="pt-3 pb-2">
                  <h5 style={{
                    textAlign: 'center',
                    fontFamily: 'var(--font-heading)',
                    fontSize: '1.5rem',
                    fontWeight: 700,
                    color: 'var(--color-text)',
                    marginBottom: 24
                  }}>SIGN IN</h5>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-25">
                      <label htmlFor="number" style={{ fontFamily: 'var(--font-body)', fontWeight: 500 }}>PH. NO:</label>
                    </div>
                    <div className="col-75">
                      <input
                        type="text"
                        id="number"
                        name="phonenumber"
                        placeholder="Phone Number"
                        onChange={(e) => handlePhoneChange(e)}
                        value={phoneNumber}
                        style={{ borderRadius: 6 }}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-25">
                      <label htmlFor="password" style={{ fontFamily: 'var(--font-body)', fontWeight: 500 }}>Password:</label>
                    </div>
                    <div className="col-75">
                      <input
                        type="password"
                        id="password"
                        name="password"
                        placeholder="*********"
                        onChange={(e) => handlePasswordChange(e)}
                        value={password}
                        style={{ borderRadius: 6 }}
                      />
                    </div>
                  </div>
                </div>

                <hr style={{ borderColor: 'var(--color-border)', marginTop: 20 }}></hr>
                <button className="button" style={{ margin: '8px auto', display: 'block', width: '100%', textAlign: 'center' }} onClick={LoginUser}>Login</button>
                <div style={{ textAlign: 'center', marginTop: 12 }}>
                  <a href="/" style={{ color: 'var(--color-primary)', fontFamily: 'var(--font-body)', fontWeight: 500 }}>Home</a>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
export default Login;
